import { z } from "zod";

export const ERROR_CODES = [
  "INVALID_INPUT",
  "UNAUTHENTICATED",
  "INVALID_RECOVERY_CODE",
  "RECOVERY_RATE_LIMITED",
  "NOT_ENOUGH_GOLD",
  "ITEM_ALREADY_OWNED",
  "ITEM_NOT_OWNED",
  "ITEM_UNAVAILABLE",
  "ACHIEVEMENT_LOCKED",
  "LEVEL_LOCKED",
  "INVALID_LEVEL_PROOF",
  "UNSUPPORTED_CONTENT_VERSION",
  "SYNC_CONFLICT",
  "SERVICE_TEMPORARILY_UNAVAILABLE",
  "FEATURE_DISABLED",
  "PROFILE_COOLDOWN",
  "RATE_LIMITED",
  "NOT_FOUND",
  "PAYLOAD_TOO_LARGE",
  "INTERNAL",
] as const;

export const errorCodeSchema = z.enum(ERROR_CODES);
export type ErrorCode = z.infer<typeof errorCodeSchema>;

export const apiErrorSchema = z.object({
  error: z.object({
    code: errorCodeSchema,
    message: z.string(),
    retryAfterSec: z.number().int().nonnegative().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof apiErrorSchema>;

/** HTTP status for each code; the Worker and client agree on retry semantics. */
export const ERROR_STATUS: Record<ErrorCode, number> = {
  INVALID_INPUT: 400,
  UNAUTHENTICATED: 401,
  INVALID_RECOVERY_CODE: 400,
  RECOVERY_RATE_LIMITED: 429,
  NOT_ENOUGH_GOLD: 409,
  ITEM_ALREADY_OWNED: 409,
  ITEM_NOT_OWNED: 409,
  ITEM_UNAVAILABLE: 404,
  ACHIEVEMENT_LOCKED: 409,
  LEVEL_LOCKED: 409,
  INVALID_LEVEL_PROOF: 422,
  UNSUPPORTED_CONTENT_VERSION: 422,
  SYNC_CONFLICT: 409,
  SERVICE_TEMPORARILY_UNAVAILABLE: 503,
  FEATURE_DISABLED: 503,
  PROFILE_COOLDOWN: 429,
  RATE_LIMITED: 429,
  NOT_FOUND: 404,
  PAYLOAD_TOO_LARGE: 413,
  INTERNAL: 500,
};

/** Codes where retrying the same request later can succeed. */
export function isRetryableError(code: ErrorCode): boolean {
  return (
    code === "SERVICE_TEMPORARILY_UNAVAILABLE" ||
    code === "RATE_LIMITED" ||
    code === "SYNC_CONFLICT" ||
    code === "INTERNAL"
  );
}
